function r(e) {
  var o = e.parentNode;
  o && o.removeChild(e);
}
export { r as removeNode };
